import { Formik, Form } from "formik"
import { Link } from "react-router-dom"
import { TRIM_TYPES, trimTextValue } from "../../../components/FieldTypes/helpers/trimTextValue"

// Prime
import { InputText as Input } from "primereact/inputtext"
import { Password } from "primereact/password"
import { Messages } from "primereact/messages"

// Static Files
import styles from "../../../styles/Form.module.css"

export default function FormProfile({
  fields = {},
  onSubmitHandler,
  messageRef = undefined,
}) {
  const defaultFields = {
    staff_name_first: "",
    staff_name_last: "",
    staff_email_address: "",
    staff_password: "",
  }

  const initialValues = {
    ...defaultFields,
    ...fields,
  }

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={async (values) => {
        onSubmitHandler({
          variables: values,
        })
      }}
    >
      {({ values, isValid, setFieldValue }) => (
        <Form className={styles.form}>
          <div className={styles.blockWrapper}>
            <div className={styles.block}>
              <div className={styles.field}>
                <label className={styles.label} htmlFor="staff_name_first">
                  First name:
                </label>
                <Input
                  id="staff_name_first"
                  name="staff_name_first"
                  value={values.staff_name_first}
                  onChange={({ target: { value } }) =>
                    setFieldValue("staff_name_first", trimTextValue(value))
                  }
                  className={styles.value}
                />
              </div>
              <div className={styles.field}>
                <label className={styles.label} htmlFor="staff_name_last">
                  Last name:
                </label>
                <Input
                  id="staff_name_last"
                  name="staff_name_last"
                  value={values.staff_name_last}
                  onChange={({ target: { value } }) =>
                    setFieldValue("staff_name_last", trimTextValue(value))
                  }
                  className={styles.value}
                />
              </div>
              <div className={styles.field}>
                <label className={styles.label} htmlFor="staff_email_address">
                  Primary account email address:
                </label>
                <div className={styles.description}>
                  A valid email address. All emails from the system will be sent
                  to this address. <br />
                  The email address is not made public and will only be used if
                  you wish to receive a new password or wish to receive certain
                  news or notifications by email.
                </div>
                <Input
                  disabled
                  id="staff_email_address"
                  name="staff_email_address"
                  value={values.staff_email_address}
                  onChange={({ target: { value } }) =>
                    setFieldValue("staff_email_address", trimTextValue(value, TRIM_TYPES.BOTH))
                  }
                  className={styles.value}
                />
              </div>
              <div className={styles.field}>
                <label className={styles.label} htmlFor="staff_password">
                  Password
                </label>
                <Password
                  value={values.staff_password}
                  onChange={(e) =>
                    setFieldValue("staff_password", e.target.value)
                  }
                  className={styles.value}
                />
              </div>

              <button type="submit" className="btn" disabled={!isValid}>
                Save
              </button>
              <Link to={`/`} className={styles.btnBack}>
                Back
              </Link>
            </div>
            <div
              style={{
                margin: "10px 0",
                background: "#9afa9a9c",
                position: "absolute",
                bottom: "57px",
                right: "17px",
                borderRadius: "12px",
              }}
            >
              <Messages ref={messageRef} />
            </div>
          </div>
        </Form>
      )}
    </Formik>
  )
}
